// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"13":"adm","204":"Research","370":"Metrics","553":"candidates","722":"notFound","966":"login"}[chunkId] || chunkId) + "." + {"13":"86a6b87e","125":"c7cfd397","179":"8f8f9ef2","204":"ac53e93e","234":"63c34dfb","370":"7d3754d1","553":"15574c74","722":"609345c0","922":"3e46af45","966":"f1c8be34"}[chunkId] + ".js";
};